import React, {Component} from 'react';
import {withTranslation} from "react-i18next";
import BasePopup from './BasePopup';

class ConfirmationPopUp extends Component {

  render() {
    const {open, title, message, confirmAction, cancelAction} = this.props;
    return (
      <BasePopup
        open={open}
        className="modal-sm"
        title={title}
        onClose={cancelAction}
        body={
          <>
            <p>{message}</p>
          </>
        }
        footer={
          <>
            <button type="button" className="btn btn-secondary" onClick={confirmAction}>
              {("CONFIRM")}
            </button>
            <button type="button" className="btn btn-outline-secondary" onClick={cancelAction}>
              {("CANCEL")}
            </button>
          </>
        }
      />
    );
  }
}

export default withTranslation()(ConfirmationPopUp);
